/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Fancy_Vast_Otter_SniffInputs */

const fr_fancy_vast_otter_sniff = /** @type {(inputs: Fancy_Vast_Otter_SniffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre abonnement sera annulé le ${i?.date}`)
};

/**

* @param {Fancy_Vast_Otter_SniffInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_sniff = /** @type {((inputs: Fancy_Vast_Otter_SniffInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_SniffInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_sniff(inputs)
});